import * as Yup from 'yup';
import editCargoFormModel from './editParameterFormModel';

const {
  formField: {
    e_llegadas_tarde,
    e_salidas_tarde,
    e_salario_minimo,
    e_auxilio_transporte,
    e_interes_cesantias,
    e_year,
  },
} = editCargoFormModel;

export default [
  Yup.object().shape({
    [e_llegadas_tarde.name]: Yup.string().required(`${e_llegadas_tarde.requiredErrorMsg}`),
    [e_salidas_tarde.name]: Yup.string().required(`${e_salidas_tarde.requiredErrorMsg}`),
    [e_salario_minimo.name]: Yup.string().required(`${e_salario_minimo.requiredErrorMsg}`),
    [e_auxilio_transporte.name]: Yup.string().required(`${e_auxilio_transporte.requiredErrorMsg}`),
    [e_interes_cesantias.name]: Yup.string().required(`${e_interes_cesantias.requiredErrorMsg}`),
    [e_year.name]: Yup.string().required(`${e_year.requiredErrorMsg}`),
  }),
];
